import { useState, useContext, useEffect, useRef } from "react";
import { labellingApi } from "../api/labelling-api";
import { connectWebSocket, disconnectWebSocket, subscribe, sendWebSocketMessage } from "../lib/websocket";
import { GlobalInfoContext } from '../GlobalInfoContext';
import { jumpToLoginPage } from "../lib/browser-utils";

export const usePhotoLocking = (currentUser, temp) => {
    const [lockedPhotos, setLockedPhotos] = useState({});
    const globalInfo = useContext(GlobalInfoContext);
    if (globalInfo.user.email == "") {
        jumpToLoginPage();
    }

    useEffect(() => {
        const setupLocking = () => {
            labellingApi.getLockedPhotos({ status: temp }).then(initialLocks => {
                setLockedPhotos(initialLocks || {});
            });
            subscribe('/topic/photoStatus', (payload) => {
                setLockedPhotos(payload.lockedPhotos || {});
            });
        };

        connectWebSocket(setupLocking);

        return () => {
            if (globalInfo.user?.userId) {
                sendWebSocketMessage('/app/photo/unlock', {
                    userId: globalInfo.user.userId,
                    status: temp
                });
            }
            disconnectWebSocket();
        };
    }, []);

    const lockPhoto = (photoId) => {
        if (globalInfo.user?.userId && photoId) {
            sendWebSocketMessage('/app/photo/lock', {
                photoId: photoId,
                userId: globalInfo.user.userId,
                status: temp
            });
        }
    };

    const unlockPhoto = () => {
        if (globalInfo.user?.userId) {
            sendWebSocketMessage('/app/photo/unlock', {
                userId: globalInfo.user.userId,
                status: temp
            });
        }
    };

    return { lockedPhotos, lockPhoto, unlockPhoto };
};